import api from '../api';

import { ParamsBodyPaymentSlipApp } from 'utils/typeServices';

type ParamsResponse = {
    Data: any;
}

export const PostPaymentSlipApp = async ({ token, body }: { token: string, body: ParamsBodyPaymentSlipApp }) => {
    const bodyJson = JSON.stringify(body);

    try {
        const { data } = await api.post<ParamsResponse>('/v1/Pagamento/GeneratePaymentSlipApp', bodyJson, {
            headers: {
                'Authorization': 'Bearer ' + token
            }
        });

        return { data: data.Data };
    } catch (error) {
        console.error('error', error);
        return { data: null };
    }
}
